import { Pipe, PipeTransform } from '@angular/core';
import { SheetActionAlertService } from '../services/sheet-action-alert.service';
import { ActionAlertTestCondition } from '../types/aggregate-graph.types';

@Pipe({
	name: 'actionAlertConditionOperator',
	standalone: true
})
export class ActionAlertConditionOperatorPipe implements PipeTransform {

	constructor(private sheetActionAlertService: SheetActionAlertService) { }

	transform(alertCondition: ActionAlertTestCondition): string {
		return this.sheetActionAlertService.getSign(alertCondition);
	}
}
